import React from 'react';

/**
 * Renderiza el bloque FeederDetails de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function FeederDetails({
  v
}) {
  return React.createElement("aside", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03),0 0.925926vh 2.777778vh rgba(0,0,0,0.25)",
      "padding": "1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.296296vh",
      "minHeight": "0"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "minHeight": "0",
      "flex": "1"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text(v.fsRankT)), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "overflow": "auto",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh",
      "paddingRight": "0.208333vw"
    }
  }, (v.fsRank || []).map((k, index150) => React.createElement(React.Fragment, {
    key: index150
  }, React.createElement("div", {
    "onClick": k.onClick,
    style: {
      "display": "grid",
      "gridTemplateColumns": "1.041667vw minmax(0,1fr) 3.75vw 3.020833vw",
      "gap": "0.740741vh",
      "alignItems": "center",
      "padding": "0.462963vh 0.555556vh",
      "borderRadius": "0.462963vh",
      "cursor": "pointer",
      "background": k.bg
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text(k.n)), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "minWidth": "0"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(k.name)), React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "background": "#1c2636",
      "borderRadius": "0.185185vh",
      "display": "flex"
    }
  }, React.createElement("span", {
    style: {
      "height": "0.277778vh",
      "borderRadius": "0.185185vh",
      "width": k.w,
      "background": k.bc
    }
  }, null))), React.createElement("svg", {
    "viewBox": "0 0 100 30",
    "preserveAspectRatio": "none",
    style: {
      "width": "3.75vw",
      "height": "2.222222vh",
      "display": "block"
    }
  }, React.createElement("path", {
    "d": k.mid,
    "stroke": "#2a3446",
    "strokeDasharray": "2 2",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null), React.createElement("path", {
    "d": k.spark,
    "stroke": k.vc,
    "strokeWidth": "1.5",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null)), React.createElement("span", {
    style: {
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": k.vc,
      "textAlign": "right",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v))))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "paddingTop": "1.111111vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "justifyContent": "space-between",
      "gap": "0.925926vh"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "1.296296vh",
      "fontWeight": "600",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(v.fsSelT)), React.createElement("span", {
    style: {
      "font": "600 2.037037vh 'IBM Plex Mono',monospace",
      "color": v.fsSelC
    }
  }, v.text(v.fsSelV))), v.text("\n        "), (v.fsComp || []).map((c, index151) => React.createElement("div", {
    key: index151,
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "padding": "0.185185vh 0",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "#8793a6",
      "minWidth": "0"
    }
  }, v.text(c.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": c.c,
      "textAlign": "right",
      "whiteSpace": "nowrap"
    }
  }, v.text(c.v)))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "flexWrap": "wrap"
    }
  }, v.fsDetailAvailable ? React.createElement("button", {
    "onClick": v.fsOpenDetail,
    "title": "Abrir el desglose de visitas y dimensiones",
    style: {
      "background": "rgba(232,78,14,0.12)",
      "border": "0.092593vh solid rgba(232,78,14,0.65)",
      "color": "#ff8a5b",
      "borderRadius": "0.555556vh",
      "padding": "0.462963vh 1.111111vh",
      "cursor": "pointer",
      "font": "600 1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("⌕ Información detallada")) : null, React.createElement("button", {
    "onClick": v.fsGoDet,
    style: {
      "background": "#16213a",
      "border": "0.092593vh solid oklch(0.78 0.12 250)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.462963vh 1.111111vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("Ver detalle diario ›"))), v.text("\n      ")), v.text("\n    "));
}
